<template>
    <div id="content">
        <div class="admin-page-header">
            <div>
                <h1 class="admin-page-title">{{ $t('plans.list.title') }}</h1>
                <p class="admin-page-subtitle">{{ $t('plans.list.subtitle') }}</p>
            </div>
        </div>
        <div class="row g-4">
            <div v-for="p in plans" :key="p.id" class="col-md-4">
                <div class="admin-card admin-card-hover plan-card">
                    <div class="plan-card-head">
                        <h3 class="plan-card-title text-gradient">{{ p.title.toUpperCase() }}</h3>
                        <div class="plan-card-price">
                            <span class="plan-card-price-value">{{ p.price ? p.price.toLocaleString() + ' ₸' : $t('plans.list.free') }}</span>
                            <span v-if="p.price" class="plan-card-cycle">/ {{ cycles[p.cycle - 1].text }}</span>
                        </div>
                    </div>
                    <div class="plan-card-body">
                        <div v-for="(l, index) in Object.values(p.limits).slice(0, 6)" :key="index" class="plan-limit">
                            <div v-html="displayLimit(l)"></div>
                        </div>
                    </div>
                    <div class="plan-card-actions">
                        <button v-if="user.role == 'admin'" class="btn-ghost w-100 justify-content-center" disabled>{{ $t('plans.list.unavailable') }}</button>
                        <router-link :to="'/plans/buy/'+p.id" v-else-if="user?.pl_id === p.id" class="btn-ghost w-100 justify-content-center">{{ $t('plans.list.settings') }}</router-link>
                        <router-link :to="'/plans/buy/'+p.id" v-else class="btn-purple w-100 justify-content-center">{{ $t('plans.list.start') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cycles } from '../../../lib/utils'

export default {
    data:() => ({
        plans: [],
        user: {},
        limits: [],
        cycles: cycles,
        modules: []
    }),
    computed: {
        moduleNames() {
            return [
                'SuperQR',
                this.$t('plans.list.moduleNames.onlineStore'),
                this.$t('plans.list.moduleNames.onlineQueue'),
                this.$t('plans.list.moduleNames.timeTracking'),
                'MVoter'
            ]
        }
    },
    async mounted() {
        this.plans = await this.getPlans()
        this.user = await this.getUser()
        this.limits = await this.getLimits()
    },
    methods: {
        displayLimit(l) {
            let html = ''
            if(l.function_limit && l.function_limit != 'null') {
                html += `<i class="bi bi-check-circle-fill plan-limit-on"></i>${l.name}${!isNaN(l.function_limit) ? ` - <b>${l.function_limit}</b>` : ''}`
            } else {
                html += `<i class="bi bi-x-circle plan-limit-off"></i>${l.name}`
            }
            return html
        },
        async paymentLink(plan_id, user_id, provider = 'garantpay') {
            if(!user_id || !plan_id) return false

            let plan = await this.$api.getPlan(plan_id)

            if(plan.result === 'ERROR') {
                return false
            }

            let response = await this.$api.purchase(plan.data.price, plan_id, user_id, provider)

            if(response.result === 'ERROR') {
                this.$notify({
                    text: response.msg || response.message || this.$t('plans.plan.paymentError'),
                    type: 'error'
                })
                return false
            }

            // Stripe → full-page redirect to hosted checkout
            if(response?.data?.checkout_url) {
                window.location.href = response.data.checkout_url
                return
            }

            // GarantPay: ссылка лежит в data.url. Раньше здесь проверялся
            // response.url — его не существует, поэтому вместо страницы
            // оплаты всегда срабатывал router.go() и страница просто
            // перезагружалась. Переход в текущей вкладке (а не window.open)
            // — новую вкладку после await режет блокировщик всплывающих окон;
            // возврат обеспечивает returnUrl на стороне провайдера.
            if(response?.data?.url) {
                window.location.href = response.data.url
            } else {
                this.$notify({
                    text: this.$t('plans.plan.paymentError'),
                    type: 'error'
                })
            }
        },
        async getPlans() {
            let r = await this.$api.getPlansWithLimits()
            if(r.result === 'SUCCESS') {
                return r.data.plans
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return []
            }
        },
        async getUser() {
            let r = await this.$api.getUser()
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return false
            }
        },
        async getLimits() {
            let r = await this.$api.getLimits()
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return []
            }
        }
    }
}
</script>

<style scoped>
.plan-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px;
}

.plan-card-head {
    text-align: center;
    padding-bottom: 18px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 18px;
}

.plan-card-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 12px 0;
    letter-spacing: 0.02em;
}

.plan-card-price {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
}

.plan-card-price-value {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
}

.plan-card-cycle {
    font-size: 14px;
    color: #64748b;
}

.plan-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 18px;
}

.plan-limit {
    font-size: 14px;
    color: #1e293b;
}
.plan-limit :deep(.plan-limit-on) {
    color: #16a34a;
    margin-right: 10px;
    font-size: 16px;
}
.plan-limit :deep(.plan-limit-off) {
    color: #cbd5e1;
    margin-right: 10px;
    font-size: 16px;
}
.plan-limit :deep(b) {
    color: #6d28d9;
}

.plan-card-actions {
    margin-top: auto;
}

.justify-content-center {
    justify-content: center;
}
.w-100 {
    width: 100%;
}
</style>
